import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import { Badge, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import { StyledIconButton } from '../../../../styles/PageHeaderStyles'

type NotificationIconProps = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  unseenNotificationsCount: number
}

const NotificationIcon = ({ setOpen, unseenNotificationsCount }: NotificationIconProps) => {
  return (
    <Tooltip
      title={<Typography variant="caption">{t('components.tooltip.notifications')}</Typography>}
      placement="bottom"
    >
      <span>
        {unseenNotificationsCount > 0 ? (
          <Badge
            badgeContent={unseenNotificationsCount}
            color="error"
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.6rem',
                minWidth: 16,
                height: 16,
                marginRight: 1,
                marginTop: 0.5,
              },
            }}
          >
            <StyledIconButton onClick={() => setOpen(true)} size="small">
              <NotificationsActiveIcon />
            </StyledIconButton>
          </Badge>
        ) : (
          <StyledIconButton onClick={() => setOpen(true)} size="small">
            <NotificationsActiveIcon />
          </StyledIconButton>
        )}
      </span>
    </Tooltip>
  )
}

export default NotificationIcon
